<template>
  <Navbar />
  <div class="row">
    <div class="col-8 offset-2 mt-5">
      <div class="card px-4 py-4 border-0">
        <div class="card-title text-dark text-center">
          <h1 class="error-page-title">{{ code }}</h1>
        </div>

        <div class="card-body text-center text-dark mb-3">
          <h3 id="message">{{ message || $t('ERROR_DEFAULT_MESSAGE') }}</h3>
        </div>

        <div class="card-action">
          <div class="text-center">
            <!-- temp redirected to login -->
            <router-link :to="{name: 'login'}" class="btn btn-dark">{{ $t('LABEL_BUTTON_TOP_PAGE') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { HTTP_CODE_SERVER_ERROR } from "@/data/constants";
import Navbar from "@/components/Navbar.vue";

const code = window.history.state.code || HTTP_CODE_SERVER_ERROR;
const message = window.history.state.message;

</script>